import LazyLoad from "vanilla-lazyload"

document.addEventListener("DOMContentLoaded", () => {
  // eslint-disable-next-line no-new
  new LazyLoad({
    elements_selector: "[data-lazy]",
  })
})



// WEBPACK FOOTER //
// ./src/blocks/index.js